/**
 * @param index the index where the element will be put
 * @returns ((stack, value) => stack) this function will add the value to the stack at the index
 */
export const addToStack =
  (index: number) =>
  <T>(stack: T[], value: T): T[] => [...stack.slice(0, index), value];

/**
 * @param to as in "forward" or "backward"
 * @param index the index to move to
 * @returns the next index or undefined
 */
export const moveIndex = (to: 'fwd' | 'bwd', index = -1) =>
  to === 'fwd' ? index + 1 : index > 0 ? index - 1 : undefined;
